import { render, staticRenderFns } from "./MerckTooltip.vue?vue&type=template&id=3805fc70&scoped=true&"
import script from "./MerckTooltip.vue?vue&type=script&lang=js&"
export * from "./MerckTooltip.vue?vue&type=script&lang=js&"
import style0 from "./MerckTooltip.vue?vue&type=style&index=0&id=3805fc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805fc70",
  null
  
)

export default component.exports